import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Route } from 'react-router';
import PackerDeliveryDayMarketplaceView from './packerDeliveryDayMarketplaceView';
import PackerDeliveryDayMarketplaceRefunds from './packerDeliveryDayMarketplaceRefunds';
import { useDeliveryDayMarketplace } from './apiHooks';
import Loader from '../../components/loader';
import ErrorMessage from '../../components/errorMessage';
import utils from '../../utils/utils';
import Helmet from 'react-helmet';
import DATE_FORMAT from '../../components/constants/dateFormat';
import { NavLink } from 'react-router-dom';
import PackerDeliveryDayMarketplaceIndividual from './packerDeliveryDayMarketplaceIndividual';
import DELIVERY_DAY_MARKETPLACE_INVENTORY_STATUS from '../../components/constants/deliveryDayMarketplaceInventoryStatus';
import PackerDeliveryDayMarketplaceCombinedOrderItems from './packerDeliveryDayMarketplaceCombinedOrderItems';

const PackerDeliveryDayMarketplace = ({ match }) => {
  const {
    deliveryDayMarketplace,
    isLoading: getLoading,
    isError: isGetError,
    error: getError,
  } = useDeliveryDayMarketplace(match.params.deliveryDayMarketplaceId);

  const { formatMessage } = useIntl();

  if (!deliveryDayMarketplace) {
    return <Loader />;
  }

  return (
    <div>
      <Loader show={getLoading} />
      {isGetError ? <ErrorMessage error={utils.getErrorMessageFromResponse(getError)} /> : ''}

      <div className="m-b-3">
        <Helmet>
          <title>
            {deliveryDayMarketplace
              ? `${deliveryDayMarketplace.marketplaceName} - ${utils.getFormattedDateFromString(
                  deliveryDayMarketplace.deliveryDate,
                  DATE_FORMAT.onlyDate
                )}`
              : formatMessage({ id: 'packer.delivery.day.marketplace.inventory.title' })}
          </title>
        </Helmet>
        <h2>
          {deliveryDayMarketplace ? (
            <>{`${deliveryDayMarketplace.marketplaceName} - ${utils.getFormattedDateFromString(
              deliveryDayMarketplace.deliveryDate,
              DATE_FORMAT.onlyDate
            )}`}</>
          ) : (
            <FormattedMessage id={'packer.delivery.day.marketplace.inventory.title'} />
          )}
        </h2>

        {deliveryDayMarketplace ? (
          <>
            <div>
              <FormattedMessage
                id={'packer.delivery.day.marketplace.inventory.status'}
                values={{ status: deliveryDayMarketplace.inventoryStatus || '-' }}
              />
            </div>
            {deliveryDayMarketplace.inventoryStatus ? (
              <div>
                <FormattedMessage
                  id={'packer.delivery.day.marketplace.inventory.by'}
                  values={{ name: deliveryDayMarketplace.inventoryBy?.screenName || '-' }}
                />
              </div>
            ) : (
              ''
            )}
            <div>
              {deliveryDayMarketplace.orderItemsFulfilled ? (
                <FormattedMessage id={'packer.delivery.day.marketplace.inventory.refunds.order.items.fulfilled'} />
              ) : (
                <FormattedMessage id={'packer.delivery.day.marketplace.inventory.refunds.order.items.not.fulfilled'} />
              )}
            </div>
            {deliveryDayMarketplace.inventoryStatus === DELIVERY_DAY_MARKETPLACE_INVENTORY_STATUS.completeWithErrors ? (
              <div>
                {deliveryDayMarketplace.refundsDone ? (
                  <FormattedMessage id={'packer.delivery.day.marketplace.inventory.refunds.order.items.refunded'} />
                ) : (
                  <FormattedMessage id={'packer.delivery.day.marketplace.inventory.refunds.order.items.not.refunded'} />
                )}
              </div>
            ) : (
              ''
            )}
          </>
        ) : (
          ''
        )}
      </div>

      <div>
        <ul className="list-unstyled list-inline m-b-6 p-a-0">
          <li className="list-inline-item">
            <NavLink className="link" to={`${match.url}`} exact>
              <FormattedMessage id={'packer.delivery.day.marketplace.links.inventory'} />
            </NavLink>
          </li>
          <li className="list-inline-item">
            <NavLink className="link" to={`${match.url}/combinedOrderItems`} exact>
              <FormattedMessage id={'packer.delivery.day.marketplace.links.live.orders'} />
            </NavLink>
          </li>
          <li className="list-inline-item">
            <NavLink className="link" to={`${match.url}/refunds`}>
              <FormattedMessage id={'packer.delivery.day.marketplace.links.refunds'} />
            </NavLink>
          </li>
          <li className="list-inline-item">
            <NavLink className="link" to={`${match.url}/individual`}>
              <FormattedMessage id={'packer.delivery.day.marketplace.links.individual'} />
            </NavLink>
          </li>
        </ul>
      </div>

      <Route
        exact
        path={`${match.path}`}
        render={(props) => (
          <PackerDeliveryDayMarketplaceView deliveryDayMarketplace={deliveryDayMarketplace} {...props} />
        )}
      />
      <Route
        path={`${match.path}/combinedOrderItems`}
        render={(props) => (
          <PackerDeliveryDayMarketplaceCombinedOrderItems deliveryDayMarketplace={deliveryDayMarketplace} {...props} />
        )}
      />
      <Route
        path={`${match.path}/refunds`}
        render={(props) => (
          <PackerDeliveryDayMarketplaceRefunds deliveryDayMarketplace={deliveryDayMarketplace} {...props} />
        )}
      />
      <Route
        path={`${match.path}/individual`}
        render={(props) => (
          <PackerDeliveryDayMarketplaceIndividual deliveryDayMarketplace={deliveryDayMarketplace} {...props} />
        )}
      />
    </div>
  );
};

PackerDeliveryDayMarketplace.propTypes = {
  currentUser: PropTypes.object,
};

PackerDeliveryDayMarketplace.defaultProps = {};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

export default injectIntl(connect(mapStateToProps)(PackerDeliveryDayMarketplace));
